import { Divider } from "@mui/material";

const CustomDivider = ({style}) => {
    return (<Divider sx={{ borderBottomWidth: 2, borderBottomColor: "#FF7F50" }} style={style} />);
}

export default CustomDivider;